import React, { useState } from "react";
import BtnLoader from "../BtnLoader/BtnLoader";
import DimensionInput from "../DimensionInput";
import ElevationInput from "../ElevationInput";
import Select from "react-select";
import SubmitButton from "./SubmitButton";

const AirportForm = (props) => {
  const {
    formFields,
    setFormFields,
    loaders,
    formErrorsAirport,
    setFormErrorsAirport,
    handleSubmit,
  } = props;
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedFuel, setSelectedFuel] = useState(null);
  const colourOptions = [
    { value: "chocolate", label: "Asphalt" },
    { value: "strawberry", label: "Concrete" },
    { value: "Grass", label: "Grass" },
    { value: "Gravel", label: "Gravel" },
    { value: "Ice", label: "Ice" },
    { value: "Sand", label: "Sand" },
    { value: "Snow", label: "Snow" },
    { value: "Water", label: "Water" },
    { value: "Other", label: "Other" },
  ];
  const FuelOptions = [
    { value: "100LL", label: "100LL" },
    { value: "Jet-A", label: "Jet-A" },
    { value: "Jet-A1", label: "Jet-A1" },
    { value: "Jet-A+", label: "Jet-A+" },
    { value: "Jet-B", label: "Jet-B" },
    { value: "MoGas", label: "MoGas" },
    { value: "other", label: "Other" },
  ];
  const validateField = (name, value, index) => {
    let errors = [...formErrorsAirport];
    const isFieldEmpty = Array.isArray(value)
      ? value.length === 0
      : !value.trim();

    if (isFieldEmpty) {
      errors[index] = { ...errors[index], [name]: "This field is required." };
    } else if (errors[index]) {
      delete errors[index][name];
    }

    console.log("Errors after setting fuel validation:", errors);

    setFormErrorsAirport(errors);
  };

  console.log("Form fields:", selectedFuel);

  const handleCloningAirPort = (e, index) => {
    const { name, value } = e.target;
    console.log(name, value);
    const fields = [...formFields];
    fields[index][name] = value;
    setFormFields(fields);
    validateField(name, value, index);
  };

  const handleOrientationInput = (e, index) => {
    let { value } = e.target;
    value = value.replace(/[^\d]/g, "");
    if (value.length > 2) {
      value = value.slice(0, 2) + "/" + value.slice(2);
    }
    if (value.length > 5) {
      value = value.slice(0, 5);
    }
    const fields = [...formFields];
    fields[index]["orientation"] = value;
    setFormFields(fields);
  };

  const addField = () => {
    setFormFields([
      ...formFields,
      {
        airport_use: "",
        ctaf_unicom: "",
        dimensions: "",
        elevation: "",
        fuel: [],
        lighting: "",
        operation_hours: "",
        orientation: "",
        condition: "",
        parking: "",
        pattern: "",
        surface: [],
        ground_transportation: "",
        distance_from_runway: "",
      },
    ]);
    setSelectedOption(null);
    setSelectedFuel(null);
  };

  const removeField = (index) => {
    setFormFields(formFields.filter((_, i) => i !== index));
    setFormErrorsAirport(formErrorsAirport.filter((_, i) => i !== index));
  };

  return (
    <>
      <div className="grid md:grid-cols-12 bg-white p-4 rounded-lg gap-4">
        <h3 className="text-xl font-bold text-center md:col-span-12">
          Airport Information
        </h3>

        {formFields?.map((field, index) => (
          <>
            <div className="md:col-span-4 text-left">
              <label>Identifier</label>
              <input
                type="text"
                placeholder="Identifier"
                name="identifer"
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                value={field.identifer}
                onChange={(e) => handleCloningAirPort(e, index)}
              />
              {formErrorsAirport[index]?.identifer && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].identifer}
                </p>
              )}
            </div>
            <div className="md:col-span-4 text-left">
              <label>Airport Name</label>
              <input
                type="text"
                placeholder="Airport Name"
                name="airport_name"
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                value={field.airport_name}
                onChange={(e) => handleCloningAirPort(e, index)}
              />
              {formErrorsAirport[index]?.airport_name && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].airport_name}
                </p>
              )}
            </div>
            <div className="md:col-span-4 text-left">
              <label>Airport Use</label>
              <select
                value={field.airport_use}
                name="airport_use"
                onChange={(e) => handleCloningAirPort(e, index)}
                className="border border-input px-3 py-3 rounded-md gap-4 w-full"
              >
                <option value="">Airport Use</option>
                <option value="Public">Public</option>
                <option value="Private">Private</option>
                <option value="Private - permission required to land">
                  Private - permission required to land
                </option>
              </select>
              {formErrorsAirport[index]?.airport_use && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].airport_use}
                </p>
              )}
            </div>
            <div className="md:col-span-4 text-left">
              <label>Operation Hours</label>
              <input
                type="text"
                placeholder="Operation Hours"
                name="operation_hours"
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                value={field.operation_hours}
                onChange={(e) => handleCloningAirPort(e, index)}
              />
              {formErrorsAirport[index]?.operation_hours && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].operation_hours}
                </p>
              )}
            </div>
            <div className="md:col-span-4 text-left">
              <label>Lighting</label>
              <div className="listsearch-input-item">
                <select
                  value={field.lighting}
                  name="lighting"
                  onChange={(e) => handleCloningAirPort(e, index)}
                  className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                >
                  <option disabled value="">
                    select
                  </option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {formErrorsAirport[index]?.lighting && (
                  <p style={{ color: "red" }}>
                    {formErrorsAirport[index].lighting}
                  </p>
                )}
              </div>
            </div>
            <div className="md:col-span-4 text-left">
              <label>CTAF/UNICOM</label>
              <input
                type="text"
                placeholder="CTAF/UNICOM"
                name="ctaf_unicom"
                value={field.ctaf_unicom}
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                onChange={(e) => handleCloningAirPort(e, index)}
              />
              {formErrorsAirport[index]?.ctaf_unicom && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].ctaf_unicom}
                </p>
              )}
            </div>
            <div className="md:col-span-6 text-left">
              <label>Fuel</label>
              <Select
                value={selectedFuel}
                onChange={(selectedFuel) => {
                  const fields = [...formFields];
                  const selectedFuelValues = selectedFuel.map(
                    (option) => option.value
                  ); // Extract values only
                  fields[index]["fuel"] = selectedFuelValues; // Store values array
                  setFormFields(fields);
                  setSelectedFuel(selectedFuel);

                  // Validate fuel field on every change
                  validateField("fuel", selectedFuelValues, index);
                }}
                isMulti
                options={FuelOptions}
              />
              {formErrorsAirport[index]?.fuel && (
                <p style={{ color: "red" }}>{formErrorsAirport[index].fuel}</p>
              )}
            </div>

            <div className="md:col-span-6 text-left">
              <label>Parking</label>
              <div className="listsearch-input-item">
                <select
                  value={field.parking}
                  name="parking"
                  onChange={(e) => handleCloningAirPort(e, index)}
                  className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                >
                  <option value="">Select Parking</option>
                  <option value="Hangar">Hangar</option>
                  <option value="Hangar and Tie-downs">
                    Hangar and Tie-downs
                  </option>
                  <option value="Tie-downs">Tie-downs</option>
                </select>
                {formErrorsAirport[index]?.parking && (
                  <p style={{ color: "red" }}>
                    {formErrorsAirport[index].parking}
                  </p>
                )}
              </div>
            </div>

            <div className="md:col-span-6 text-left">
              <label>Orientation</label>
              <input
                type="text"
                placeholder="Orientation"
                name="orientation"
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                value={field.orientation}
                onChange={(e) => handleOrientationInput(e, index)}
                maxLength={5}
                pattern="\d{2}/\d{2}"
              />
              {formErrorsAirport[index]?.orientation && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].orientation}
                </p>
              )}
            </div>
            <div className="md:col-span-6 text-left">
              <DimensionInput
                key={index}
                value={field.dimensions}
                index={index}
                formFields={formFields}
                setFormFields={setFormFields}
              />
            </div>

            <div className="md:col-span-6 text-left">
              <label>Surface</label>
              <Select
                defaultValue={selectedOption}
                onChange={(selectedOption) => {
                  const fields = [...formFields];
                  fields[index]["surface"] = selectedOption;
                  setFormFields(fields);
                  setSelectedOption(selectedOption);
                }}
                isMulti
                options={colourOptions}
                styles={{
                  option: (baseStyles, state) => ({
                    ...baseStyles,
                    position: "relative",
                    zIndex: 100,
                  }),
                }}
              />
              {formErrorsAirport[index]?.surface && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].surface}
                </p>
              )}
            </div>

            <div className="md:col-span-6 text-left">
              <label>Condition</label>
              <input
                type="text"
                placeholder="Condition"
                name="condition"
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                value={field.condition}
                onChange={(e) => handleCloningAirPort(e, index)}
              />
              {formErrorsAirport[index]?.condition && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].condition}
                </p>
              )}
            </div>

            <div className="md:col-span-6 text-left">
              <label>Pattern</label>
              <div className="listsearch-input-item">
                <select
                  value={field.pattern}
                  name="pattern"
                  onChange={(e) => handleCloningAirPort(e, index)}
                  className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                >
                  <option value="">Select Pattern</option>
                  <option value="left, left">left, left</option>
                  <option value="left, right">left, right</option>
                  <option value="right, left">right, left</option>
                  <option value="right, right">right, right</option>
                </select>
                {formErrorsAirport[index]?.pattern && (
                  <p style={{ color: "red" }}>
                    {formErrorsAirport[index].pattern}
                  </p>
                )}
              </div>
            </div>
            <div className="md:col-span-6 text-left">
              <ElevationInput
                key={index}
                value={field.elevation}
                index={index}
                formFields={formFields}
                setFormFields={setFormFields}
              />
            </div>

            <div className="md:col-span-6 text-left">
              <label>Distance from Runway to Accommodations</label>
              <div className="listsearch-input-item">
                <select
                  value={field.distance_from_runway}
                  name="distance_from_runway"
                  onChange={(e) => handleCloningAirPort(e, index)}
                  className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                >
                  <option value="">Select Distance</option>
                  <option value="0 miles">0 miles</option>
                  <option value="0 to 1 miles">0 to 1 miles</option>
                  <option value="1.1 to 3 miles">1.1 to 3 miles</option>
                  <option value="3.1 to 7 miles">3.1 to 7 miles</option>
                  <option value="7+ miles">7+ miles</option>
                </select>
                {formErrorsAirport[index]?.distance_from_runway && (
                  <p style={{ color: "red" }}>
                    {formErrorsAirport[index].distance_from_runway}
                  </p>
                )}
              </div>
            </div>

            <div className="md:col-span-6 text-left">
              <label>Airnav.com Information</label>
              <input
                type="text"
                placeholder="https://airnav.com/airport/"
                name="air_nav"
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                value={field.air_nav || "https://airnav.com/airport/"}
                onChange={(e) => handleCloningAirPort(e, index)}
              />
              {formErrorsAirport[index]?.air_nav && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].air_nav}
                </p>
              )}
            </div>

            <div className="dashboard-title md:col-span-12 text-left">
              <h4>Ground Transportation</h4>
            </div>
            <div className="md:col-span-6 text-left">
              <select
                value={field.ground_Transportation}
                name="ground_Transportation"
                onChange={(e) => handleCloningAirPort(e, index)}
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
              >
                <option value="">Select Transportation</option>
                <option value="We have a courtesy car waiting for you!">
                  We have a courtesy car waiting for you!
                </option>
                <option value="We have a car you can rent from us!">
                  We have a car you can rent from us!
                </option>
                <option value="Rent a car right in the airport! Their phone number is:">
                  Rent a car right in the airport! Their phone number is:
                </option>
                <option value="We will give you a ride to the nearest rental car agency!">
                  We will give you a ride to the nearest rental car agency!
                </option>
                <option value="We have a deal with the FBO so you can keep the car your whole stay!">
                  We have a deal with the FBO so you can keep the car your whole
                  stay!
                </option>
                <option value="You don't need a car here!">
                  You don't need a car here!
                </option>
              </select>
              {formErrorsAirport[index]?.ground_Transportation && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].ground_Transportation}
                </p>
              )}
            </div>

            <div className="md:col-span-6 text-left">
              <input
                type="text"
                placeholder="Additional Information"
                name="ground_transportation"
                className="flex border border-input px-3 py-3 rounded-md gap-4 items-center w-full"
                value={field.ground_transportation}
                onChange={(e) => handleCloningAirPort(e, index)}
              />
              {formErrorsAirport[index]?.ground_transportation && (
                <p style={{ color: "red" }}>
                  {formErrorsAirport[index].ground_transportation}
                </p>
              )}
            </div>

            <div className="md:col-span-12 flex justify-start items-start">
              {formFields?.length > 1 && (
                <button
                  className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
                  onClick={() => removeField(index)}
                >
                  Remove
                </button>
              )}
            </div>

            <div className="md:col-span-12 text-left flex justify-end items-end">
              <button
                onClick={addField}
                className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
              >
                Add Airport
              </button>
            </div>
          </>
        ))}

        <div className="md:col-span-12 text-left flex justify-end items-end gap-4">
          <button className="border border-[#3b4249] font-medium bg-[#54c4d9] rounded-md text-white px-8 py-3">
            {loaders ? <BtnLoader /> : <>Save as Draft</>}
          </button>
          <SubmitButton handleSubmit={handleSubmit} loaders={loaders} />
        </div>
      </div>
    </>
  );
};

export default AirportForm;
